import Bowser from 'bowser'

// Recommended browsers from Chase.com
// https://www.chase.com/digital/resources/privacy-security/security/system-requirements

export const isSupportedBrowser = () => {
  // istanbul ignore else : not needed
  if (typeof window !== 'undefined') {
    const SUPPORTED_BROWSERS = {
      chrome: '>=72',
      safari: '>=11',
      firefox: '>=76',
      edge: '>=16',
      electron: '>=1',
      google_search: '>=72',
    }
    return Object.entries(SUPPORTED_BROWSERS).some(([name, version]) => {
      const browser = Bowser.getParser(window.navigator.userAgent)
      return (
        browser.getOSName(true) === 'ios' ||
        browser.satisfies({ [name]: version })
      )
    })
  }
}
